module.exports = __webpack_public_path__ + "img/FI21937564.ac1e01e0.svg";